module.exports = __webpack_public_path__ + "static/media/bank_icon.289b1784.svg";